export default __webpack_public_path__ + "static/media/livingroom3.37373959.webp";